import FrontEndApi from '../../../../Common/Globals/Scripts/FrontEndApi';
import Moment from 'moment';

async function loadAuditRecords(fromInclusive, toExclusive) {
    const interval = Moment(fromInclusive).toISOString() + " to " + Moment(toExclusive).toISOString();
    const apiCutOff = 100;
    const result = await FrontEndApi.getRateCardActionAuditLogEntries(interval, apiCutOff + 1)
    for(const r of result) {
        r.actionCompletedAt = new Date(r.actionCompletedAt);
    }
    if (result.length > apiCutOff) {
        return { rows: result.slice(0, apiCutOff), apiCutOffExceeded: true }
    }

    return { rows: result, apiCutOffExceeded: false };
}

async function downloadFile(rateCardActionAuditId, action) {
    return await FrontEndApi.getRateCardActionAuditFileContent(rateCardActionAuditId, action == "UpdateViaApi" ? FrontEndApi.exportType.Xml : FrontEndApi.exportType.Csv);
}

async function downloadAuditReportFile(rateCardActionAuditIds) {
    return await FrontEndApi.getRateCardActionAuditReport(rateCardActionAuditIds, FrontEndApi.exportType.Csv);
}

export default { loadAuditRecords, downloadFile, downloadAuditReportFile }
